const SERVERLESS_PREFIX = '/_serverless/app-installer-fed-serverless';
export const INSTALLER_TOPOLOGY_API_URL = `${SERVERLESS_PREFIX}/getInstallerTopology`;
export const IDENTITY_TOKEN_VALIDATION_API_URL = `${SERVERLESS_PREFIX}/getIdentityTokenValidation`;
export const getInitialAppInstallationData = _ref => {
  let {
    version,
    appId,
    tenantId,
    languageCode,
    shareUrlId
  } = _ref;
  const urlParams = new URLSearchParams({
    appId,
    ...(version ? {
      version
    } : {}),
    ...(shareUrlId ? {
      shareUrlId
    } : {}),
    tenantId,
    languageCode
  }).toString();
  return `${SERVERLESS_PREFIX}/getAppInstallationData?${urlParams}`;
};
export const getAuthHeader = _ref2 => {
  let {
    tenantId
  } = _ref2;
  const urlParams = new URLSearchParams({
    tenantId
  }).toString();
  return `${SERVERLESS_PREFIX}/getAuthHeader?${urlParams}`;
};
export const getInstallLink = () => `${window.location.origin || 'https://www.wix.com'}/_api/site-apps/v1/site-apps/bulk-install`;
export const getMetaSiteLink = () => `${window.location.origin || 'https://www.wix.com'}/_api/msm-server/v1/meta-site/get?responseData=namespace
`;
export const getInstallationSourceTokenLink = () => `${SERVERLESS_PREFIX}/installationSourceToken`;
//# sourceMappingURL=apis.js.map